import { graphql } from "relay-runtime"

export const chSaveCarePlanDataMutation = graphql`
  mutation chSaveCarePlanDataMutation($input: Ch_saveCarePlanDataInput!, $connections: [ID!]!) {
    saveCarePlanData: ch_saveCarePlanData(input: $input) {
      carePlanPreviewOutput: ch_CarePlanPreviewOutput {
        progressNoteId
        carePlanSummary @prependNode(connections: $connections, edgeTypeName: "Ch_carePlanSummaryEdge") {
          ...CarePlanSummaryFragment @relay(mask: false)
        }
        previewMarkdown
      }
    }
  }
`
